type IconProps = { className?: string };

export function YahooBrandIcon({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden>
      <rect width="24" height="24" rx="6" fill="#6001D2" />
      <path
        fill="#fff"
        d="M12 6.5l2.2 4.5 4.9.7-3.5 3.4.8 4.9L12 17.2l-4.4 2.4.8-4.9-3.5-3.4 4.9-.7L12 6.5z"
      />
    </svg>
  );
}
